import treatmentStatus from "@/data/treatmentStatus";
import treatmentManagement from "@/data/treatmentManagement";

const state = () => ({
  treatmentStatusList: treatmentStatus,
  treatmentManagement: treatmentManagement,
});

const getters = {};

const mutations = {};

const actions = {};

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
